import { animate, state, style, transition, trigger } from '@angular/animations';

const fadeOutTransition = transition(':leave', [style({ opacity: 1 }), animate('100ms ease-out', style({ opacity: 0 }))]);

export const fadeInOut = trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate('100ms ease-in', style({ opacity: 1 }))]), fadeOutTransition]);

export const fadeIn = trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('100ms ease-in', style({ opacity: 1 }))])]);

export const fadeOut = trigger('fadeOut', [fadeOutTransition]);

export const slideDown = trigger('slideDown', [
  state(
    'hidden',
    style({
      height: '0px',
      overflow: 'hidden',
      transform: 'translateY(-20px)',
      opacity: 0,
      paddingBottom: 0,
    }),
  ),
  state(
    'visible',
    style({
      height: '*',
      transform: 'translateY(0)',
      opacity: 1,
      paddingBottom: '20px',
    }),
  ),
  transition('hidden <=> visible', [animate('200ms ease-in-out')]),
]);

export const fadeInDelay = trigger('fadeInDelay', [
  transition(':enter', [
    style({
      opacity: 0,
      height: 0,
      transform: 'translateY(-20px)',
      paddingBottom: 0,
    }),
    animate(
      '150ms ease-in',
      style({
        opacity: 1,
        height: '*',
        transform: 'translateY(0)',
        paddingBottom: '20px',
      }),
    ),
  ]),
]);

export const fadeInOutH = trigger('fadeInOutH', [
  transition(':enter', [style({ width: '0px', opacity: 0 }), animate('200ms ease-in-out', style({ width: '*', opacity: 1 }))]),
  transition(':leave', [style({ width: '*', opacity: 1 }), animate('200ms ease-in-out', style({ width: 0, opacity: 0 }))]),
]);
